import React from 'react';
import style from "./ZoneRoomAdmin.module.css";
import zoneImg from '../../../assets/img/zonesMargin.png';
import InputSearch from '../../../utils/components/InputSearch/InputSearch';
import InputTextArea from '../../../utils/components/InputTextArea/InputTextArea';
import Button from '../../../utils/components/Button/Button';
const AdminEditZone = ({ zone, formik }) => {
    return <div>
        
    </div>
    return (
        <div>
            <div className={style.zone_img_container}>
                <img
                    alt="img"
                    className={`profile-picture-img`}
                    onError={(e) => (e.target.src = zoneImg)}
                    src={zoneImg}
                ></img>
            </div>
            <div className={style.zone_input_name_container}>
                <div>
                    <input className={style.zone_input} type="text" placeholder='name'  value={formik.values.name} name='name' onChange={formik.handleChange} />
                </div>
            </div>
            <div className={style.zone_input_admin_category}>
                <div className={style.zone_input_container}>
                    <div>
                        Selecciona el administrador(a)
                        <div className={style.zone_input_admin_container}>
                            <select className={style.zone_input}>
                                <option>Seleciona tipo de usuario</option>
                                <option>EcoTienda</option>
                                <option>EcoMaster</option>
                                <option>EcoCeo</option>

                            </select>

                            <InputSearch />
                        </div>
                    </div>

                </div>
                <div className={style.zone_input_container}>
                    <div>selecciona la categoría</div>

                    <div className={style.zone_input_category_container} >
                        <input readOnly className={style.zone_input} type="text" placeholder='category' value={formik.values.category.name}/>
                        <div className={style.zone_input_select_container}>
                            <div>Deportes</div>
                            <div>Juegos</div>
                            <div>Deportes</div>
                            <div>Juegos</div>
                        </div>
                    </div>
                    <div>

                        <InputTextArea placeholder={"Introduzca la descripción"}  name = 'description' setValue={(value)=>{formik.setFieldValue('description',value)} } value={formik.values.description}/>
                    </div>
                </div>
            </div>
            <div className={style.zone_btn}>
                <Button text='Guardar' />
            </div>
        </div>
    )
};

export default AdminEditZone;
